<template>
  <!-- start 打字练习操作栏 -->
  <div class="manipulation-menu">
    <div class="operation-vessel">
      <div class="operation-list">
        <img class="operation-list-icon" src="@/assets/images/time-icon.png" />
        <span class="operation-list-label">时间</span>
        <span class="operation-list-val">{{ formatSeconds(times) }}</span>
      </div>
      <div class="operation-list">
        <img class="operation-list-icon" src="@/assets/images/speed-icon.png" />
        <span class="operation-list-label">速度</span>
        <span class="operation-list-val">{{ typingSpeed }}字/分</span>
      </div>
      <div class="operation-list">
        <img
          class="operation-list-icon"
          src="@/assets/images/schedule-icon.png"
        />
        <span class="operation-list-label">进度</span>
        <span class="operation-list-val">{{ schedule }}%</span>
      </div>
      <div class="operation-list">
        <img
          class="operation-list-icon"
          src="@/assets/images/accuracy-icon.png"
        />
        <span class="operation-list-label">正确率</span>
        <span class="operation-list-val">{{ accuracy }}%</span>
      </div>
    </div>
    <div class="btn-group">
      <img
        class="btn"
        v-if="restartStatus == 0"
        src="@/assets/images/restart-default-icon.png"
        @mouseover="restartStatus = 1"
        title="重新开始"
        @click="restart"
      />
      <img
        class="btn"
        v-if="restartStatus == 1"
        src="@/assets/images/restart-immigrate-icon.png"
        @mouseleave="restartStatus = 0"
        title="重新开始"
        @click="restart"
      />
      <img
        class="btn"
        v-if="restartStatus == 2"
        src="@/assets/images/restart-click-icon.png"
        @mouseleave="restartStatus = 0"
        title="重新开始"
        @click="restart"
      />
      <img
        class="btn"
        src="@/assets/images/play-default-icon.png"
        v-if="status == 0 && playStatus == 0"
        @mouseover="playStatus = 1"
        @click="startPracticing"
        title="继续"
      />
      <img
        class="btn"
        src="@/assets/images/play-immigrate-icon.png"
        v-if="status == 0 && playStatus == 1"
        @mouseleave="playStatus = 0"
        @click="startPracticing"
        title="继续"
      />
      <img
        class="btn"
        src="@/assets/images/suspend-default-icon.png"
        v-if="status == 1 && suspendStatus == 0"
        @mouseover="suspendStatus = 1"
        @click="startPracticing"
        title="暂停"
      />
      <img
        class="btn"
        src="@/assets/images/suspend-immigrate-icon.png"
        v-if="status == 1 && suspendStatus == 1"
        @mouseleave="suspendStatus = 0"
        @click="startPracticing"
        title="暂停"
      />
      <img
        class="btn"
        src="@/assets/images/test-pattern-default-icon.png"
        v-if="testStatus == 0 && pattern == 0"
        @mouseover="testStatus = 1"
        title="测试模式"
      />
      <img
        class="btn"
        src="@/assets/images/test-pattern-immigrate-icon.png"
        v-if="testStatus == 1 && pattern == 0"
        @mouseleave="testStatus = 0"
        title="测试模式"
      />
      <img
        class="btn"
        src="@/assets/images/exercise-default-icon.png"
        v-if="exerciseStatus == 0 && pattern == 1"
        @mouseover="exerciseStatus = 1"
        title="测试模式"
      />
      <img
        class="btn"
        src="@/assets/images/exercise-immigrate-icon.png"
        v-if="exerciseStatus == 1 && pattern == 1"
        @mouseleave="exerciseStatus = 0"
        title="测试模式"
      />
    </div>
  </div>
  <!-- end 打字练习操作栏 -->
</template>

<script>
export default {
  name: "ManipulationMenu",
  data() {
    return {
      times: 0,
      task: null,
      status: 0,
      open: false,
      restartStatus: 0, //重新开始，0：默认，1：移入，2：点击
      playStatus: 0, //继续，0：默认，1：移入，
      suspendStatus: 0, //暂停，0：默认，1：移入
      testStatus: 0, //测试，0：默认，1：移入
      exerciseStatus: 0, //练习：0：默认，1：移入
      //pattern: 0, //模式：0：测试模式，1练习模式
    };
  },
  props: {
    pattern: {
      typeof: Number,
      default: 0
    },
    totalNumbeWords: {
      //总字数
      typeof: Number,
      default: 0,
    },
    correctNumberWords: {
      //正确字数
      typeof: Number,
      default: 0,
    },
    wrongNumberWords: {
      //错误字数
      typeof: Number,
      default: 0,
    },
    results: {
      typeof: String,
      default: "",
    },
  },
  watch: {
    schedule: {
      handler(newVal) {
        if (newVal == 100) {
          let param = {
            times: this.times,
            totalNumbeWords: this.totalNumbeWords,
            typingSpeed: this.typingSpeed,
            accuracy: this.accuracy,
            schedule: this.schedule,
          };
          if (this.results != null || this.results != "") {
            let data = window.localStorage.getItem(this.results);
            var myDate = new Date();
            var date =
              myDate.getFullYear() +
              "年" +
              (myDate.getMonth() + 1) +
              "月" +
              myDate.getDate() +
              "日";
            if (data != null) {
              let arr = JSON.parse(data);
              arr.push({
                score: this.typingSpeed,
                date: date,
              });
              window.localStorage.setItem(
                this.results,
                JSON.stringify(arr)
              );
            } else {
              let arr = [];
              arr.push({
                score: this.typingSpeed,
                date: date,
              });
              window.localStorage.setItem(
                this.results,
                JSON.stringify(arr)
              );
            }
          }
          clearTimeout(this.task);
          this.$emit("startWhether", false);
          this.$emit("completeTest", param);
        }
      },
    },
  },
  computed: {
    // 速度
    typingSpeed() {
      if (this.totalNumbeWords == 0) {
        return 0;
      }
      let result = parseInt(this.times);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);

      if (m <= 0) {
        return this.correctNumberWords + this.wrongNumberWords;
      }
      let number = (this.correctNumberWords + this.wrongNumberWords) / m;
      return parseInt(number);
    },
    // 进度
    schedule() {
      if (this.totalNumbeWords == 0) {
        return 0;
      }
      let number =
        (this.correctNumberWords + this.wrongNumberWords) /
        this.totalNumbeWords;
      return (number.toFixed(4) * 100).toFixed(2);
    },
    // 正确率
    accuracy() {
      if (this.correctNumberWords + this.wrongNumberWords == 0) {
        return 0;
      }
      let number =
        this.correctNumberWords /
        (this.correctNumberWords + this.wrongNumberWords);
      return (number.toFixed(4) * 100).toFixed(2);
    },
  },
  methods: {
    // 重新开始
    restart() {
      this.restartStatus == 0 || this.restartStatus == 1
        ? (this.restartStatus = 2)
        : (this.restartStatus = 0);
      this.$router.go(0);
    },
    // 计时器
    timepiece() {
      this.task = setInterval(() => {
        this.times++;
      }, 1000);
    },
    // 开始练习
    startPracticing() {
      this.status == 0 ? (this.status = 1) : (this.status = 0);
      if (this.status == 0 && this.task != null) {
        clearTimeout(this.task);
        this.$emit("startWhether", false);
      } else {
        this.timepiece();
        this.$emit("startWhether", true);
      }
    },
    // 转换时间单位
    formatSeconds(value) {
      let result = parseInt(value);

      let h =
        Math.floor((result / 3600) % 24) < 10
          ? "0" + Math.floor((result / 3600) % 24)
          : Math.floor((result / 3600) % 24);

      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);

      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);

      return h + ":" + m + ":" + s;
    },
  },
};
</script>

<style scoped lang="scss">
.manipulation-menu {
  display: flex;
  // justify-content: center;
  .operation-vessel {
    width: 545px;
    height: 30px;
    background: #ececec;
    border-radius: 14px 14px 14px 14px;
    border: 1px solid #e3e3e3;
    display: flex;
    align-items: center;
    padding: 0 14px;
    box-sizing: border-box;
    .operation-list {
      display: flex;
      align-items: center;
      flex: 1;
      .operation-list-icon {
        width: 20px;
        height: 20px;
      }
      .operation-list-label {
        margin-left: 10px;
        font-size: 12px;
        font-weight: 400;
        color: #000000;
      }
      .operation-list-val {
        margin-left: 10px;
        font-weight: 400;
        color: #ff4d4d;
        font-size: 12px;
      }
    }
  }
  .btn-group {
    .btn {
      margin-left: 12px;
      width: 30px;
      height: 30px;
    }
  }
}
</style>
